import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./PaymentHistory.module.css";
import imageWhite from "../../assets/images/dashboard/payment-history-white.svg";
import { TableOptions } from "../../utils/messageConstants";
import { Link } from "react-router-dom";
import { checkIfPermitted, Permissions } from "../../services/RolePermissionService";

let order = "desc";
function detailFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    cell.charAt(0).toUpperCase() + cell.slice(1)
  }`;
}
export class PaymentHistory extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleBtnClick = () => {
    if (order === "desc") {
      this.refs.table.handleSort("asc", "name");
      order = "asc";
    } else {
      this.refs.table.handleSort("desc", "name");
      order = "desc";
    }
  };

  render() {
    const dashboardCountData = this.props.dashboardCounts;
    return (
      <div>
        <div className={`card ${style.paymentHistoryCard}`}>
          <Link to={checkIfPermitted(Permissions.VIEW_PAYMENT_TRANSACTION) 
          ? "/app/paymenthistory" : "/app/dashboard"}>
            <div className={`card-header ${style.paymentHistoryHeader}`}>
              <div className="d-flex align-items-center dashboard-list-box">
                <img src={imageWhite} alt="Pending Approvals" />
                Payment History
              </div>
              <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
            </div>
          <div className="card-body dashboard-time-table-wrapper">
            <BootstrapTable ref="table" data={dashboardCountData.paymentHistory} options={TableOptions} version="4">
              <TableHeaderColumn
                dataField="transaction_id"
                isKey={true}
                // dataSort={true}
                width={"65%"}
              >
                Transaction Id
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="payment_type"
                // dataSort={true}
                dataFormat={detailFormatter}
                width={"35%"}
              >
                Type
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
          </Link>
        </div>
      </div>
    );
  }
}


export default PaymentHistory;

